import styled from 'styled-components';
import { InterestForm } from './ForCreatorSectionOne';
import Typography, { TypeVariant } from 'shared/Typography';

const Wrapper = styled.div`
  display: flex;
  margin-bottom: 100px;
  margin-top: 150px;
  justify-content: center;

  @media (max-width: 1025px) {
    flex-direction: column;
    align-items: center;
    margin-top: 60px;
  } ;
`;

const Container = styled.div`
  margin-right: 70px;
  padding-top: 25px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    margin-right: 0px;
  } ;
`;

const TitleWrap = styled.div`
  max-width: 310px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    max-width: 100%;
  } ;
`;

const DescriptionWrapper = styled.div`
  margin-top: 20px;
  max-width: 400px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    padding: 0 30px;
  } ;
`;

const SectionEight = () => (
  <Wrapper>
    <Container>
      <TitleWrap>
        <Typography
          variant={TypeVariant.header02}
          as="h5"
          color="var(--color-white)"
          tablet={TypeVariant.subtitle01}
          textAlign={{ default: 'left', tablet: 'center' }}
        >
          Your Community
          <br />
          Enhanced
        </Typography>
      </TitleWrap>

      <DescriptionWrapper>
        <Typography
          variant={TypeVariant.bodyLarge01}
          tablet={TypeVariant.body01}
          as="p"
          color="var(--color-white)"
          textAlign={{ default: 'left', tablet: 'center' }}
        >
          We're excited to chat with you and any of your friends who would enjoy
          Solin!
        </Typography>
      </DescriptionWrapper>
    </Container>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <InterestForm />
    </div>
  </Wrapper>
);

export default SectionEight;
